package fr.labodoc.domain.labodoc

class InputFile(
  val name: String?,
  val mime: String,
  val content: ByteArray
)
